import script from "./blockList.vue?vue&type=script&setup=true&lang=ts"
export * from "./blockList.vue?vue&type=script&setup=true&lang=ts"

import "./blockList.vue?vue&type=style&index=0&id=59f8291d&lang=scss&scoped=true"

import exportComponent from "/home/circleci/project/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59f8291d"]])

export default __exports__